export const APPS_HEIGHT_STORAGE_KEY = 'sia.appsSectionHeightPx'
export const APPS_HEIGHT_MIN = 200
export const APPS_HEIGHT_MAX = 600
export const APPS_HEIGHT_DEFAULT = 215

export function readStoredAppsHeight() {
  try {
    const raw = localStorage.getItem(APPS_HEIGHT_STORAGE_KEY)
    if (raw == null) return APPS_HEIGHT_DEFAULT
    const n = parseInt(raw, 10)
    if (Number.isNaN(n)) return APPS_HEIGHT_DEFAULT
    return Math.min(APPS_HEIGHT_MAX, Math.max(APPS_HEIGHT_MIN, n))
  } catch {
    return APPS_HEIGHT_DEFAULT
  }
}
